import { render } from "./CardInfoConfig.vue?vue&type=template&id=152a71a0"
import script from "./CardInfoConfig.vue?vue&type=script&lang=js"
export * from "./CardInfoConfig.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__